export const isObject = (obj) => obj && typeof obj === 'object';
//# sourceMappingURL=is-object.js.map